// extracted by mini-css-extract-plugin
module.exports = {"container":"ConsoleChatMainContainer_container__aPZzT","hides_side_menu":"ConsoleChatMainContainer_hides_side_menu__W_V2f"};